<!-- CONTENUTO -->
<div class="container my-5">
  <div class="row">
    <div class="col-12">
      <div class="row titolo-pagina">
        <div class="col-12">
          <h1 class="">
            {{'IMPOSTA_NUOVA_PASSWORD' | translate | htmlToText}}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <form name="form" (ngSubmit)="f.form.valid && conferma()" #f="ngForm" [mustMatch]="['password', 'confirmPassword']" novalidate>
            <div class="form-group">
              <label for="passwordTemp" class="font-weight-semi-bold small">{{ 'PASSWORD_TEMPORANEA' | translate | htmlToText  }}*</label>
              <input type="password" class="form-control" name="passwordTemp" id="passwordTemp" placeholder="" [(ngModel)]="jsonIn.passwordTemporanea"
               #passwordTemp="ngModel" [ngClass]="{ 'is-invalid': f.submitted && passwordTemp.invalid }" required minlength="10" maxlength="10" >
              <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                <div *ngIf="passwordTemp.errors.required">{{ 'PASSWORD' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                <div *ngIf="passwordTemp.errors.minlength || passwordTemp.errors.maxlength">{{ 'DATO_NON_VALIDO' | translate | htmlToText  }}</div>
              </div>
            </div>

            <div class="form-group">
              <label for="password" class="font-weight-semi-bold small">{{ 'PASSWORD' | translate | htmlToText  }}*</label>
              <input type="password" class="form-control" name="password" id="password" placeholder="" [(ngModel)]="jsonIn.nuovaPassword"
               #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required minlength="6" >
              <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                <div *ngIf="password.errors.required">{{ 'PASSWORD' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                <div *ngIf="password.errors.minlength">{{ 'PASSWORD_LENEGTH' | translate | htmlToText  }}</div>
              </div>
            </div>
            <div class="form-group">
              <label for="confirmPassword" class="font-weight-semi-bold small">{{ 'RIPETI_PASSWORD' | translate | htmlToText  }}*</label>
              <input type="password" class="form-control" name="confirmPassword" id="confirmPassword"
                placeholder="" [(ngModel)]="jsonIn.nuovaPasswordConferma"
                #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }" required>
              <!-- ERRORE DATO INVALIDO -->
              <!-- <div class="is-invalid small" *ngIf="passwordNonCoincidono"><i>{{ 'PASSWORD_NON_COINCIDONO' | translate | htmlToText  }}</i></div> -->
              <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                <div *ngIf="confirmPassword.errors.required">{{ 'RIPETI_PASSWORD' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                <div *ngIf="confirmPassword.errors.mustMatch">{{ 'PASSWORDS_MATCH' | translate | htmlToText  }}</div>
              </div>
            </div>
            <div class="form-inline mb-3">
              <button class="btn btn-stem mr-4" type="submit">
                {{'IMPOSTA_PASSWORD' | translate | htmlToText}}
                </button>
            </div>
            <div class="small">*{{'CAMPI_OBBLIGATORI' | translate | htmlToText}}</div>

            <div class="is-invalid small" *ngIf="errore"><i>{{'ERRORE_RESET_PASSWORD' | translate | htmlToText}}</i></div>
          </form>
          
          
        
        </div>

      </div>
      
      
    </div>
  </div>
</div>